import { render, staticRenderFns } from "./AddOtpuskModal.vue?vue&type=template&id=70a0c8d1&scoped=true&"
import script from "./AddOtpuskModal.vue?vue&type=script&lang=js&"
export * from "./AddOtpuskModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOtpuskModal.vue?vue&type=style&index=0&id=70a0c8d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0c8d1",
  null
  
)

export default component.exports